export function groupBy(data: any[], key: string) {
  return data.reduce((total, next) => {
    (total[next[key]] = total[next[key]] || []).push(next);
    return total;
  }, {});
}
